<div class="scoringToolTipBase">
    <app-scoring-cell
        *ngIf="params"
        [params]="params"
        [showName]="true"
    ></app-scoring-cell>
    <div
        class="scoringToolTipMetrics"
        *ngFor="let item of tooltipMetrics | keyvalue"
    >
        <div>
            {{ item.key }}
        </div>
        <div>
            {{ item.value | number: '1.2-2' }}
        </div>
    </div>
</div>
